module.exports = __webpack_public_path__ + "static/media/home-frame.c7ecb2c5.png";